<template>
  <div v-if="productFamily?.variants?.length">
    <NuxtLink 
      @click.prevent="onSelect(variant)"
      v-for="(variant, index) in productFamily.variants"
      :key="variant.productId" 
      :to="variant.productUrl" 
      class="block rounded-[0.4285714286rem] p-3 mb-3 last:mb-0 border hover:border-gray-900 cursor-pointer" 
      :class="[variant.productId === activeProductId ? 'border-2 border-gray-900' : 'border-ash-300']" 
      :aria-label="`Select ${variant.productName}`" 
      :title="`Select ${variant.productName}`" 
      :id="`product-variant-${index}`"
      external
    >
      <div class="text-ash-500">{{ variant.productName }}</div>
      <div class="text-gray-700 text-[0.8571428571rem]">{{ variant.unitCount }} {{ variant.servingType }}</div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import type {ProductFamily, ProductVariant} from '~~/shared/types/common'
defineProps<{
  productFamily?: ProductFamily
  activeProductId?: Number
}>()

const emit = defineEmits<{
  (e: 'select', variant: ProductVariant): void
}>()

const onSelect = (variant: ProductVariant) => {
  emit('select', variant)
}

</script>
